import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import supabase from '../../../../supabaseClient';

const CourseDetail = () => {
  const { courseId } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCourse = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('academy_courses')
        .select('*')
        .eq('id', courseId)
        .single();
      if (error) setError(error.message);
      else setCourse(data);
      setLoading(false);
    };
    fetchCourse();
  }, [courseId]);

  if (loading) return <div>Loading course...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!course) return <div>Course not found.</div>;

  return (
    <div className="academy-page-shell course-detail-page">
      <div className="course-detail">
        <h2>{course.title}</h2>
        <p>{course.description}</p>
        <p><strong>Instructor:</strong> {course.teacher_id}</p>
        {/* Add more course fields as needed */}
        <button className="btn-copy-link" onClick={() => navigator.clipboard.writeText(window.location.href)}>
          Copy Link
        </button>
      </div>
    </div>
  );
};

export default CourseDetail;
